import { defineMessages } from 'react-intl';

export const ratingInfoMessages = defineMessages({
  ratingsHintLabel: {
    id: 'ratingsHint.label',
    defaultMessage: 'Hinweise zu Bewertungen',
  },
});
